import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { getBreakpoints, getListado } from 'skrit-web-framework/utils';
import translate from 'skrit-web-framework/translator';
import Stepper from 'skrit-web-framework/components/Stepper';
import { withSizes } from 'react-sizes';
import { SERVER } from 'skrit-web-framework/constantes';
import { MOTOSCAT_VIEW } from '../utils/ConstantesComunes';
import Spinner from 'skrit-web-framework/components/Spinner';
import cls from 'classnames';
import Button from 'skrit-web-framework/components/buttons-new/Button';
import ByteImage from 'skrit-web-framework/components/ByteImage';

const mapStateToProps = (state) => {
    return {
        ...state.motoscat,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setMarca(idMarca, marca) {
            dispatch({ type: 'SET_MARCA', idMarca: idMarca, marca });
        },
        setModelo(idModelo, modelo) {
            dispatch({ type: 'SET_MODELO', idModelo: idModelo, modelo });
        },
        setMotor(idMotor, motor, view) {
            dispatch({
                type: 'SET_MOTOR',
                idMotor: idMotor,
                view: view,
                motor,
            });
        },
    };
};

class MarcasMotos extends Component {
    constructor(props) {
        super(props);
        this.state = {
            marcas: { ini: [], rows: [] },
            modelos: { ini: [], rows: [] },
            motores: { ini: [], rows: [] },
            step: 1,
            marca: null,
            modelo: null,
            letrasFabricantes: [],
            openLetras: false,
            letras: [],
            fabFiltrados: [],
            valueFiltro: '',
            filtroModelos: '',
            filtroVersion: '',
        };
    }

    componentDidMount() {
        getListado('/MarcasMotos', {}).then((res) => {
            this.setState({ marcas: { ini: res.rows, rows: res.rows } }, () =>
                this.orderFabByLetra()
            );
        });
    }

    componentDidUpdate(prevProps, prevState) {
        const { valueFiltro, filtroModelos, filtroVersion } = this.state;
        if (valueFiltro !== prevState.valueFiltro) {
            this.orderFabByLetra();
            return;
        }
        if (filtroModelos !== prevState.filtroModelos) {
            this.orderModelos(filtroModelos);
            return;
        }
        if (filtroVersion !== prevState.filtroVersion) {
            this.orderMotor(filtroVersion);
            return;
        }
    }

    handleFilterLetra = (letra) => (e) => {
        const { letras } = this.state;
        if (letras.includes(letra)) {
            this.setState({ letras: letras.filter((e) => e !== letra) });
        } else {
            this.setState({ letras: letras.concat(letra) });
        }
    };

    stepBack = (e) => {
        const { step } = this.state;
        this.setState({ step: step - 1 });
    };

    orderFabByLetra() {
        const { marcas, valueFiltro } = this.state;
        let letras = [];
        let marcasFiltered = [];
        if (valueFiltro !== '' && valueFiltro != null) {
            marcasFiltered = marcas.rows.filter((fab) =>
                fab.MMO_DESCRIPCION.toUpperCase().includes(
                    valueFiltro.toUpperCase()
                )
            );
        } else {
            marcasFiltered = marcas.rows;
        }
        letras = [...new Set(marcasFiltered.map((e) => e.MMO_LETRA))];
        let letrasFabricantes = letras.map((e) => {
            return {
                letra: e,
                fabricantes: marcasFiltered.filter(
                    (item) => item.MMO_LETRA === e
                ),
            };
        });
        let fabFiltrados = letrasFabricantes.filter((e) =>
            letras.includes(e.letra)
        );
        this.setState({
            letras,
            fabFiltrados,
            letrasFabricantes,
        });
    }

    orderModelos(filtroModelos) {
        const { modelos } = this.state;
        if (filtroModelos == null || filtroModelos === '') {
            this.setState((prevState) => ({
                modelos: { ...prevState.modelos, rows: modelos.ini },
            }));
            return;
        }
        let modelosFiltered = modelos.ini.filter((fab) =>
            fab.MMD_DESCRIPCION.toUpperCase().includes(
                filtroModelos.toUpperCase()
            )
        );
        this.setState((prevState) => ({
            modelos: { ...prevState.modelos, rows: modelosFiltered },
        }));
    }

    orderMotor(filtroVersion) {
        const { motores } = this.state;
        if (filtroVersion == null || filtroVersion === '') {
            this.setState((prevState) => ({
                motores: { ...prevState.motores, rows: motores.ini },
            }));
            return;
        }
        let motoresFiltered = motores.ini.filter((fab) =>
            fab.MOT_VERSION.toUpperCase().includes(filtroVersion.toUpperCase())
        );
        this.setState((prevState) => ({
            motores: { ...prevState.motores, rows: motoresFiltered },
        }));
    }

    selectBrand(row) {
        this.props.setMarca(row.MMO_ID, row.MMO_DESCRIPCION);
        this.setState({ marca: row.MMO_ID }, () => this.getModelos());
    }

    selectMoto(row) {
        this.props.setModelo(row.MMD_ID, row.MMD_DESCRIPCION);
        this.setState({ modelo: row.MMD_ID }, () => this.getMotores());
    }

    articlesSelect(row) {
        this.props.setMotor(
            row.MOT_ID,
            row.MOT_VERSION,
            MOTOSCAT_VIEW.REFERENCIA
        );
    }

    getModelos() {
        getListado('/ModelosMotos', {
            MMD_ID_MARCA_MOTO: this.state.marca,
        }).then((res) => {
            this.setState({
                modelos: { ini: res.rows, rows: res.rows },
                step: 2,
            });
        });
    }

    getMotores() {
        getListado('/Motos', {
            MOT_ID_MARCA_MOTO: this.state.marca,
            MOT_ID_MODELO_MOTO: this.state.modelo,
        }).then((res) => {
            this.setState({
                motores: { ini: res.rows, rows: res.rows },
                step: 3,
            });
        });
    }

    renderStepper() {
        const { step } = this.state;
        return (
            <Stepper step={step}>
                <div className='step-thin' step={1}>
                    <div className='step-number'>1</div>
                    <div className='step-content hidden-xs'>
                        {translate('seleccione_fabricante')}
                    </div>
                </div>
                <div className='step-thin' step={2}>
                    <div className='step-number'>2</div>
                    <div className='step-content hidden-xs'>
                        {translate('seleccione_modelo')}
                    </div>
                </div>
                <div className='step-thin' step={3}>
                    <div className='step-number'>3</div>
                    <div className='step-content hidden-xs'>
                        {translate('seleccione_motor')}
                    </div>
                </div>
            </Stepper>
        );
    }

    renderLetrasFabricantes() {
        const { letrasFabricantes, letras, fabFiltrados, valueFiltro } =
            this.state;
        return (
            <Fragment>
                <div className='col-12'>
                    <div className='row px-3'>
                        <div className='col-12'>
                            <input
                                type='text'
                                className='form-control mb-3'
                                value={valueFiltro}
                                onChange={(e) =>
                                    this.setState({
                                        valueFiltro: e.target.value || '',
                                    })
                                }
                                placeholder={translate('buscar_fabricante')}
                            />
                        </div>
                        <div className='col-12'>
                            {letrasFabricantes.map((e, i) => {
                                return (
                                    <button
                                        key={i}
                                        className={cls(
                                            'btn rounded-0 btn-letra',
                                            {
                                                active: letras.includes(
                                                    e.letra
                                                ),
                                            }
                                        )}
                                        onClick={() =>
                                            this.handleFilterLetra(e.letra)
                                        }
                                        style={{ marginRight: '0.1rem' }}
                                    >
                                        {e.letra}
                                    </button>
                                );
                            })}
                            <button
                                className='btn btn-transparent rounded-0 mr-4 py-0'
                                onClick={(e) => this.setState({ letras: [] })}
                            >
                                <i className='ms-Icon ms-Icon--Cancel' />
                            </button>
                        </div>
                        <div className='col-12'>
                            <div className='row fabricantes px-3'>
                                {fabFiltrados.map((element, index) => {
                                    return (
                                        <div
                                            key={index}
                                            className='col-12 mt-3 group'
                                        >
                                            <h1 className='letter'>
                                                {element.letra}
                                            </h1>
                                            {/* <hr /> */}
                                            <div className='row'>
                                                {element.fabricantes.map(
                                                    (fab, index) => {
                                                        return (
                                                            <div
                                                                key={index}
                                                                className='col-4'
                                                            >
                                                                <button
                                                                    className='btn btn-transparent'
                                                                    onClick={() =>
                                                                        this.selectBrand(
                                                                            fab
                                                                        )
                                                                    }
                                                                >
                                                                    {
                                                                        fab.MMO_DESCRIPCION
                                                                    }
                                                                </button>
                                                            </div>
                                                        );
                                                    }
                                                )}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }

    renderBrands() {
        const { marcas, letrasFabricantes, openLetras } = this.state;
        if (
            marcas != null &&
            (marcas.rows == null ||
                marcas.rows.length === 0 ||
                letrasFabricantes == null)
        ) {
            return <Spinner />;
        }
        if (marcas.rows && marcas.rows.length > 0) {
            return (
                <Fragment>
                    <div className='row px-3'>
                        <div className='col-12 d-flex justify-content-end align-items-center mb-3'>
                            <Button
                                label='Buscar por letra'
                                onClick={() =>
                                    this.setState((prevState) => ({
                                        openLetras: !prevState.openLetras,
                                    }))
                                }
                            />
                        </div>
                        {openLetras && this.renderLetrasFabricantes()}
                        {!openLetras &&
                            marcas.rows.map((row) => {
                                return (
                                    <div
                                        className='col-2'
                                        onClick={() => this.selectBrand(row)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <ByteImage
                                            src={`${SERVER}/DocumentosAdjuntos/ObtenerDocumentoAdjunto/${row.MMO_ID_DOC}/2`}
                                            default={'Styles/img/user.svg'}
                                        />
                                    </div>
                                );
                            })}
                    </div>
                </Fragment>
            );
        }
        return null;
    }

    renderModelos() {
        const { modelos, filtroModelos } = this.state;
        if (modelos != null && modelos.rows) {
            return (
                <Fragment>
                    <div className='brand-content row px-3'>
                        <div className='col-12 d-flex justify-content-end'>
                            <input
                                type='text'
                                className='form-control mb-3'
                                value={filtroModelos}
                                onChange={(e) =>
                                    this.setState({
                                        filtroModelos: e.target.value || '',
                                    })
                                }
                                placeholder={translate('buscar_modelo')}
                                autoFocus
                            />
                        </div>
                        <div className='col-12 scroll-box'>
                            <table className='table table-striped table-hover table-responsive-lg'>
                                <thead>
                                    <tr>
                                        <th>{translate('marca')}</th>
                                        <th>{translate('modelo')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {modelos.rows.length > 0 &&
                                        modelos.rows.map((modelo) => {
                                            return (
                                                <tr
                                                    onClick={() =>
                                                        this.selectMoto(modelo)
                                                    }
                                                    style={{
                                                        cursor: 'pointer',
                                                    }}
                                                >
                                                    <td>
                                                        {modelo.MMO_DESCRIPCION}
                                                    </td>
                                                    <td>
                                                        {modelo.MMD_DESCRIPCION}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                </tbody>
                            </table>
                        </div>
                        <div className='col-12 d-flex justify-content-end'>
                            <Button
                                onClick={this.stepBack}
                                label={translate('atras')}
                            />
                        </div>
                    </div>
                </Fragment>
            );
        }
        return null;
    }

    renderMotos() {
        const { motores, filtroVersion } = this.state;
        if (motores != null && motores.rows && motores.rows.length > 0) {
            return (
                <Fragment>
                    <div className='brand-content row px-3'>
                        <div className='col-12'>
                            <input
                                type='text'
                                className='form-control mb-3'
                                value={filtroVersion}
                                onChange={(e) =>
                                    this.setState({
                                        filtroVersion: e.target.value || '',
                                    })
                                }
                                placeholder={translate('buscar_version')}
                                autoFocus
                            />
                        </div>
                        <div className='col-12 scroll-box'>
                            <table className='table table-striped table-hover table-responsive-lg'>
                                <thead>
                                    <tr>
                                        <th>{translate('version')}</th>
                                        <th>{translate('marca')}</th>
                                        <th>{translate('modelo')}</th>
                                        <th>CC</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {motores.rows.length > 0 &&
                                        motores.rows.map((moto) => {
                                            return (
                                                <tr
                                                    onClick={() =>
                                                        this.articlesSelect(
                                                            moto
                                                        )
                                                    }
                                                    style={{
                                                        cursor: 'pointer',
                                                    }}
                                                >
                                                    <td>{moto.MOT_VERSION}</td>
                                                    <td>
                                                        {moto.MMO_DESCRIPCION}
                                                    </td>
                                                    <td>
                                                        {moto.MMD_DESCRIPCION}
                                                    </td>
                                                    <td>{moto.MOT_CC}</td>
                                                </tr>
                                            );
                                        })}
                                </tbody>
                            </table>
                        </div>
                        <div className='col-12 d-flex justify-content-end'>
                            <Button
                                onClick={this.stepBack}
                                label={translate('atras')}
                            />
                        </div>
                    </div>
                </Fragment>
            );
        }
        return null;
    }

    renderStep() {
        switch (this.state.step) {
            case 1:
                return this.renderBrands();
            case 2:
                return this.renderModelos();
            case 3:
                return this.renderMotos();
            default:
                return null;
        }
    }

    render() {
        return (
            <div className='content-container motoscat-content'>
                <div className='step-wrapper'>{this.renderStepper()}</div>
                <div className='step-motoscat-content'>{this.renderStep()}</div>
            </div>
        );
    }
}

export default withSizes(getBreakpoints)(
    connect(mapStateToProps, mapDispatchToProps)(MarcasMotos)
);
